import * as React from "react";
import { useLink } from "@grandvisionhq/frk-routing";
import { useDispatchTrackClickEvent } from "@grandvisionhq/svc-tealium/events";
import { useIsApplePaySupportedForCart } from "../../../../../../hooks/hooks/use-is-apple-pay-supported-for-cart.js";
import { ApplePayButton } from "./ApplePayButton.js";
import { ExpressPaymentMethod, PaymentMethod } from "../../../../../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const ApplePayExpressCheckoutButtonContainer = ({
  cartId,
  cartHash,
  onClickHandler
}) => {
  const dispatchTealiumTrackEvent = useDispatchTrackClickEvent();
  const cartLink = useLink({ route: "cart.overview" });
  const expressCheckoutLink = useLink({
    route: "express-checkout",
    params: {
      type: ExpressPaymentMethod.APPLE_PAY,
      returnPath: cartLink?.href,
      cartId,
      ...cartHash ? { cartHash } : null
    }
  });
  const handleOnClick = React.useCallback(() => {
    dispatchTealiumTrackEvent({
      data_element_id: "Summary_ApplePayCheckout",
      data_description: "checkout_with_applepay"
    });
    onClickHandler && onClickHandler(PaymentMethod.APPLE_PAY);
    expressCheckoutLink && expressCheckoutLink.onClick();
  }, [expressCheckoutLink, onClickHandler, dispatchTealiumTrackEvent]);
  const { isApplePaySupportedForCart, called, loading } = useIsApplePaySupportedForCart(cartId);
  if (!isApplePaySupportedForCart || !called || loading) {
    return null;
  }
  if (!expressCheckoutLink) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(ApplePayButton, { onClick: handleOnClick });
};
export {
  ApplePayExpressCheckoutButtonContainer
};
//# sourceMappingURL=ApplePayExpressCheckoutButtonContainer.js.map
